var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFinmoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1499 9.67013C19.1499 15.0109 14.8634 19.3405 9.57568 19.3405C8.14931 19.3405 6.7958 19.0254 5.57962 18.4605C5.32279 19.6528 5.1875 20.8909 5.1875 22.161C5.1875 31.7299 12.8676 39.487 22.3414 39.487C31.8151 39.487 39.4952 31.7299 39.4952 22.161C39.4952 12.5921 31.8151 4.83496 22.3414 4.83496C20.8944 4.83496 19.4893 5.01591 18.1471 5.35662C18.7889 6.6552 19.1499 8.12007 19.1499 9.67013Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57816 18.4607C6.96081 12.0418 11.8658 6.95083 18.1456 5.35682C16.576 2.18111 13.3273 0 9.57422 0C4.28653 0 0 4.32955 0 9.67033C0 13.5704 2.28584 16.9313 5.57816 18.4607Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinmoIcon);
export default __webpack_public_path__ + "static/media/finmo-icon.1b376fd3c3b389442e8995d632b0c6b1.svg";
export { ForwardRef as ReactComponent };